<sc-content-spacer vertical></sc-content-spacer>
<sc-detail-layout-editor [itemProvider]="itemProvider" [layout]="layout" (changed)="onChange()"></sc-detail-layout-editor>
